document.addEventListener('DOMContentLoaded', function () {
    var allCategoriesCheckbox = document.getElementById('show-all-categories');
    var categoryCheckboxes = document.querySelectorAll('.faq-category-checkbox');
    var dropdownToggle = document.querySelector('.faq-dropdown-toggle');

    allCategoriesCheckbox.addEventListener('change', function () {
        if (allCategoriesCheckbox.checked) {
            // If "Show All" is checked, check all category checkboxes and show all FAQs
            categoryCheckboxes.forEach(function (checkbox) {
                checkbox.checked = true;
            });
            displayFaqGroups(true);
            updateToggleText();
        } else {
            // If "Show All" is unchecked, uncheck all category checkboxes and hide all FAQs
            categoryCheckboxes.forEach(function (checkbox) {
                checkbox.checked = false;
            });
            displayFaqGroups(false);
            updateToggleText();
        }
    });

    // Function to update the toggle text with the number of selected categories
    function updateToggleText() {
        var checkedCategories = document.querySelectorAll('.faq-category-checkbox:checked').length;
        var toggleText = checkedCategories > 0
            ? checkedCategories + ' categories selected'
            : 'Choose Category';

        dropdownToggle.textContent = toggleText;
    }

    categoryCheckboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
            updateShowAllCheckbox();
            displayFaqGroups();
            updateToggleText();
        });
    });

    categoryCheckboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
            // Update "Show All" checkbox based on individual category checkboxes
            updateShowAllCheckbox();
            // Display FAQs based on selected categories
            displayFaqGroups();
        });
    });

    function updateShowAllCheckbox() {
        var allChecked = true;
        categoryCheckboxes.forEach(function (checkbox) {
            if (!checkbox.checked) {
                allChecked = false;
            }
        });
        allCategoriesCheckbox.checked = allChecked;
    }

    function displayFaqGroups(showAll = false) {
        var faqGroups = document.querySelectorAll('.faq-category-group');
        faqGroups.forEach(function (group) {
            if (showAll) {
                group.style.display = 'flex';
            } else {
                var category = group.getAttribute('data-category-group');
                var checkbox = document.querySelector('.faq-category-checkbox[value="' + category + '"]');
                group.style.display = checkbox && checkbox.checked ? 'flex' : 'none';
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    function positionFaqDropdown() {
        var visualContent = document.querySelector('.main-visual-content');
        var faqDropdownContainer = document.querySelector('.faq-dropdown-container');

        if (visualContent && faqDropdownContainer) {
            var visualContentBottom = visualContent.getBoundingClientRect().bottom;
            var offset = 4; // Offset in pixels

            if (window.innerWidth <= 991.98) {
                const mainVisualContent = document.querySelector('.main-visual-content');
                console.log("mainVisualContent", mainVisualContent);
                if (mainVisualContent && faqDropdownContainer) {
                console.log("faqDropdownContainer", faqDropdownContainer);

                    mainVisualContent.insertAdjacentElement('beforeend', faqDropdownContainer);
                } else {
                    console.error('Could not find .main-visual-content or faqDropdownContainer element.');
                }
            } else {
                faqDropdownContainer.style.position = '';
                faqDropdownContainer.style.top = '';
            }
        }
    }

    positionFaqDropdown();
    window.addEventListener('resize', positionFaqDropdown);
});

document.addEventListener('DOMContentLoaded', function () {
    var dropdownToggle = document.querySelector('.faq-dropdown-toggle');
    var dropdownContent = document.querySelector('.faq-dropdown-content');
    var faqSection = document.querySelector('.faq-section');
    var faqDropdownContainer = document.querySelector('.faq-dropdown-container');

    dropdownToggle.addEventListener('click', function () {
        toggleDropdown();
    });

    // Function to toggle the dropdown and backdrop
    function toggleDropdown() {
        var isDisplayed = dropdownContent.style.display === 'block';
        dropdownContent.style.display = isDisplayed ? 'none' : 'block';
        faqSection.classList.toggle('with-backdrop', !isDisplayed);
    }

    // Close the dropdown when clicking outside of it
    document.addEventListener('click', function (event) {
        var isClickInside = faqDropdownContainer.contains(event.target);

        if (!isClickInside && dropdownContent.style.display === 'block') {
            toggleDropdown();
        }
    });

    // Prevent the document click from firing when clicking inside the dropdown container
    faqDropdownContainer.addEventListener('click', function (event) {
        event.stopPropagation();
    });
});
